.captionText {
  display: flex;
  justify-content: center;
  align-content: center;
  color: var(--tuna-palette-text-secondary);
}

.clickZone {
  display: flex;
  color: var(--tuna-palette-action-disabled);
  flex: 1;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
